const waitFor = delay => new Promise(resolve => setTimeout(resolve, delay));

export default waitFor;
